import {CURRENT_APPS_TO_NEW_MAP} from '../constants/constants';

export const getRenamedAppSlug = (oldAppSlug) => (CURRENT_APPS_TO_NEW_MAP[oldAppSlug]);


// WEBPACK FOOTER //
// ./src/utils/appSlugMapHelper.js